// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchResultsTable_wrapper__cX7mz","cell":"SearchResultsTable_cell__y0maB","dfp":"SearchResultsTable_dfp__JDhQM"};